import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GenericDocumentHdrLineContainerModel } from '../../../../../../models/aggregates/generic_doc';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class GenericDocHdrLineService extends BaseApiTemplateService<GenericDocumentHdrLineContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'hdr-lines/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX 
      + Core2Config.GENERIC_PREFIX + 'hdr-lines/';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX 
      + Core2Config.GENERIC_PREFIX + 'hdr-lines/';
    this.httpClient = http;
  }

  getGenericDocumentHdrLineByCriteria(doctype: string, pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<GenericDocumentHdrLineContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}${doctype}`;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocumentHdrLineContainerModel>>(
      UrlByCriteria, this.getHttpHeader(visa));
  }

}
